import { CustomModal } from "components/CustomModal";
import { LDSToast, LDSToastVariant } from "components/LDSToast";
import { useTranslation } from "react-i18next";

import type { ProcessingJob } from "../../model/types";

import { toTrimmedDetailText } from "../../lib/processingJob";

const ToastItem = ({ message, title, variant }: { message: string; title: string; variant: LDSToastVariant }) => {
  return (
    <section className="mt-6">
      <h3 className="text-lds-foreground-primary font-ds-body-semibold-md">{title}</h3>
      <LDSToast message={message} showDismiss={false} showIcon={false} showUndo={false} variant={variant} />
    </section>
  );
};

type ProcessingJobDetailsModalProps = {
  job: null | ProcessingJob;
  onClose: () => void;
};

export const ProcessingJobDetailsModal = ({ job, onClose }: ProcessingJobDetailsModalProps) => {
  const { t } = useTranslation();
  const open = job != null;

  const summary = toTrimmedDetailText(job?.details?.summary);
  const errorDetails = toTrimmedDetailText(job?.error_details);

  return (
    <CustomModal
      className="overflow-auto"
      height="auto"
      modalOpen={open}
      padding="2rem"
      setModalOpen={(value: boolean) => {
        if (!value) onClose();
      }}
      width="48rem"
    >
      <div className="text-left">
        <h2 className="font-ds-headline-lg">{t("Execution.processing.detailsModal.title")}</h2>
        {summary && <ToastItem message={summary} title={t("general.summary")} variant="neutral" />}
        {errorDetails && <ToastItem message={errorDetails} title={t("general.errorDetails")} variant="error" />}
      </div>
    </CustomModal>
  );
};
